<div class="switch input-group cpq-info-holder" [ngClass]='{"short": short, "condensed": condensed}'>
  <input id="{{name}}" name="{{name}}" [(ngModel)]="value" class="cmn-toggle cmn-toggle-round" type="checkbox" [disabled]='disabled'>
  <label for="{{name}}" [ngStyle]="{ 'cursor': disabled ? 'not-allowed' :  'pointer', 'padding-left': condensed ? '40px' : '' }">
    @if (label) {
      <span class="label-text">{{ label.value ? label.value : (label.key | translate) }}</span>
    }
  </label>
  @if (infoMessage) {
    <cpq-info class="cpq-info-icon" [message]="infoMessage" (onInfoClicked)="infoClicked()"></cpq-info>
  }
</div>